import constants from '../../constants';
import { useSelector } from 'react-redux';
import { selectImageById } from './gallerySlice';

const GalleryImage = ({imageId, index, gallerySize, selector}) => {
    const image = useSelector((state) => selector(state, imageId));

    return <div className="mySlides">
        <div className="numbertext">{++index + ' / ' + gallerySize}</div>
        <img src={constants.backend_url + image.ga_file} />
    </div>
};

export default GalleryImage;